/* eslint-disable */
export default {
  to: '받는 사람:',
  transferTo: '전달 대상',
  blindTransfer: '전달',
  warmTransfer: '먼저 확인',
  enterNameOrNumber: '번호 입력',
  toVoicemail: '음성 사서함에 보내기',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To voicemail"@#@
